/**
 * SplashScreen Component
 *
 * Displays a branded loading screen during application data preload.
 * Shows progress through sequential loading stages with visual feedback.
 */

import { useEffect, useState } from 'react'
import { Progress } from '@/components/ui/progress'
import './SplashScreen.css'

export default function SplashScreen({ isLoading = true, progress = 0, stage = '' }) {
  const [displayProgress, setDisplayProgress] = useState(0)

  useEffect(() => {
    // Smooth progress animation
    const timer = setTimeout(() => {
      setDisplayProgress(Math.max(displayProgress, progress))
    }, 50)
    return () => clearTimeout(timer)
  }, [progress, displayProgress])

  const stageLabels = {
    'farm': 'Loading farm information...',
    'products': 'Loading products...',
    'customers': 'Loading customers...',
    'branches': 'Loading branches...',
    'sales': 'Loading recent sales...',
    'complete': 'Ready to go!'
  }

  return (
    <div className={`splash-screen ${!isLoading ? 'fade-out' : ''}`}>
      {/* Full-height logo background */}
      <div className="splash-logo-background">
        <img
          src="/odinsplash.png"
          alt="Odin Farm Management"
          className="splash-logo-full"
        />
      </div>

      {/* Overlaid UI elements */}
      <div className="splash-overlay">
        {/* Title at top */}
        <div className="splash-title-section">
          <h1 className="splash-title">Odin</h1>
          <p className="splash-subtitle">Mushroom Farm Management</p>
        </div>

        {/* Center progress bar and text */}
        <div className="splash-center-content">
          {/* Divider progress bar */}
          <div className="splash-divider-container">
            <Progress
              value={displayProgress}
              className="splash-divider"
            />
          </div>

          {/* Loading Stage Text */}
          <p className="splash-stage-text">
            {stageLabels[stage] || 'Initializing...'}
          </p>
        </div>
      </div>
    </div>
  )
}
